import Image from 'next/image';
import React, { useRef, useState } from 'react';

export default function MachineSpecificGallery({ data }) {
    const demoImages = data;
    const allImages = [...demoImages, ...demoImages]; // duplicated
    const scrollRef = useRef(null);
    const [selected, setSelected] = useState(null);

    const scroll = (dir) => {
        if (!scrollRef.current) return;
        const { clientWidth } = scrollRef.current;
        scrollRef.current.scrollBy({
            left: dir === 'left' ? -clientWidth : clientWidth,
            behavior: 'smooth',
        });
    };

    return (
        <div className="section-padded machine-specific-gallery">
            <div className="gallery-container">
                <button className="arrow left" onClick={() => scroll('left')}>&lt;</button>
                <div className="gallery-scroll" ref={scrollRef}>
                    {allImages.map((img) => (
                        <div key={img.id} className="image-wrapper">
                            <Image
                                src={img.fileLink}
                                width={1920}
                                height={1080}
                                alt={img.alt || 'Machine image'}
                                className="gallery-image"
                                onClick={() => setSelected(img)}
                            />
                        </div>
                    ))}
                </div>
                <button className="arrow right" onClick={() => scroll('right')}>&gt;</button>
            </div>

            {selected && (
                <div className="modal-overlay" onClick={() => setSelected(null)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <Image
                            src={selected.fileLink}
                            width={1920}
                            height={1080}
                            alt={selected.alt || ''}
                            className="modal-image"
                        />
                        <button className="modal-close" onClick={() => setSelected(null)}>×</button>
                    </div>
                </div>
            )}
        </div>
    );
}
